import React from 'react';
import { Center, Spinner } from '@chakra-ui/react';

interface LoaderProps {
  relative?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ relative = false }) => {
  return (
    <Center height={relative ? '100%' : '100vh'}>
      <Spinner size="xl" color="primary.500" />
    </Center>
  );
};

export default Loader;
